import {AsyncStatus} from 'enums';
import {IUpdateType, IUpdateTypeAPI} from 'interfaces';
// Not using index import for services to avoid circular dependency
import {axiosAPI} from './API';
import { ManufacturersService } from './ManufacturersService';

// Singleton for interacting with update types
class _UpdateTypesService {

    public updateTypes: IUpdateType[] = [];
    public updateTypesMap: {[id: string]: IUpdateType} = {};

    public getUpdateTypes(): Promise<IUpdateType[]> {
        return axiosAPI.get<IUpdateType[]>('/updateTypes')
            .then((resp) => {
                let updateTypesResponse = resp.data;
                this.updateTypes = updateTypesResponse;
                updateTypesResponse.forEach((u) => this.updateTypesMap[u.id] = u);
                this.updateTypes = this.updateTypes.filter(u => !u.isDeleted);
                const collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});
                this.updateTypes = this.updateTypes.sort((a, b) => collator.compare(a.updateType, b.updateType));
                return updateTypesResponse;
            })
            .catch((err) => {
                console.error('Error getting update types: ', err);
                throw err;
            });
    }

    public postUpdateType(updateType: IUpdateTypeAPI): Promise<IUpdateType> {
        return axiosAPI.post<IUpdateType>('/updateTypes', updateType)
            .then((resp) => {
                let updateType = resp.data;
                this.updateTypes.push(updateType);
                this.updateTypesMap[updateType.id] = updateType;
                const collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});
                this.updateTypes = this.updateTypes.sort((a, b) => collator.compare(a.updateType, b.updateType));                
                return resp.data;
            })
            .catch((err) => {
                console.error("Error posting update type: ", err);
                throw err;
            });
    }

    public deleteUpdateType(id: number): Promise<any> {
        return axiosAPI.delete<any>(`/updateTypes/${id}`)
            .then(() => {
                // remove from list
                this.updateTypes = this.updateTypes.filter(g => g.id != id);
                this.updateTypesMap[id].isDeleted = true;
                return;
            })
            .catch((err) => {
                console.error("Error deleting update type: ", err);
                throw err;
            });
    }
}

export const UpdateTypesService = new _UpdateTypesService();